// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const RECIPE_LIST_ITEMS = "Suroviny";
export const RECIPE_SERVINGS_COUNT_number = ["%(number)s porcia", "%(number)s porcie", "%(number)s porci\u00ed"];
export const UNIT_CUP = "hrn\u010dek";
export const UNIT_DROP = "kvapka";
export const UNIT_PACK = "bal\u00ed\u010dek";
export const UNIT_PINCH = "\u0161tipka";
export const UNIT_SLICE = "pl\u00e1tok";
export const UNIT_TABLESPOON = "polievkov\u00e1 ly\u017eica";
export const UNIT_TEASPOON = "\u010dajov\u00e1 ly\u017ei\u010dka";
export const UNIT_TO_TASTE = "pod\u013ea chuti";
